import { createSharedState } from 'hooks/createSharedState';
import { useAppSelector } from 'hooks/redux';

import { isDevBuild } from 'app-components/utils/core/config';
import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { profileSelectors } from 'app-components/flux/profile';

const [useSharedDevMenuUnlocked, , setSharedDevMenuUnlocked] = createSharedState<boolean>(isDevBuild());
export { useSharedDevMenuUnlocked };

const CLICKS_TO_UNLOCK = 5;
const CLICK_WINDOW_MS = 2000;
let clickTimes: number[] = [];
export const registerDevMenuUnlockClick = () => {
  if (isDevBuild()) return;
  const now = Date.now();
  clickTimes = [...clickTimes.filter((time) => now - time < CLICK_WINDOW_MS), now];
  if (clickTimes.length < CLICKS_TO_UNLOCK) return;
  clickTimes = [];
  setSharedDevMenuUnlocked(true);
};

export const useDevMenuUnlocked = () => {
  const dev = useAppSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'dev'));
  const isInternalUser = useAppSelector((state) => {
    const email = profileSelectors.getProfile(state)?.username;
    const isInternalEmail = Boolean(email && /@(quicken|quickendev)\.com$/.test(email.trim()));
    return isInternalEmail;
  });
  const [sharedDevMenuUnlocked] = useSharedDevMenuUnlocked();
  const isDevMenuUnlocked = isDevBuild() || (sharedDevMenuUnlocked && (dev || isInternalUser));
  return isDevMenuUnlocked;
};

export default useDevMenuUnlocked;
